import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosAction } from "./axios";

export interface IBatchDeleteActionsBody {
  actionIds: ObjectId[];
}

export const useBatchDeleteActions = () => {
  const [state, execute, cancel] = axiosAction<void, IBatchDeleteActionsBody, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IBatchDeleteActionsBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
